import classNames from "classnames";
import { useAppSelector } from "hooks/hook";
import { Maximize, Menu, Minimize } from "lucide-react";
import moment from "moment";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import "react-datetime/css/react-datetime.css";
import { shallowEqual, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Collapse, Nav, NavbarToggler } from "reactstrap";
import { changeSetting, toggleSetting } from "store/reducers/settingsSlice";
import useUrlParams from "../../hooks/useUrlParams";
import AppSwitcher from "./AppSwitcher";
import RestaurantSwitcher from "./RestaurantSwitcher";

moment.updateLocale("en", {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
});

const OmsHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [restaurantId, date] = useUrlParams();
  const location = useLocation();
  const [navItem, setNavItem] = useState("");
  const { maestroMode, linkedTable, showHiddenDockets } = useAppSelector(
    (state) => ({
      maestroMode: state.root.maestroMode,
      linkedTable: state.root.linkedTable,
      showHiddenDockets: state.settings.showHiddenDockets,
    }),
    shallowEqual
  );

  useEffect(() => {
    const path = location.pathname.split("/")?.[1];
    setNavItem(path);
    dispatch(changeSetting({ name: "isCollapsed", value: true }));
  }, [location.pathname]);

  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

  useEffect(() => {
    const onFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  function toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen?.().catch(() => {});
    } else {
      document.documentElement.requestFullscreen?.().catch(() => {});
    }
  }

  // function toggleCollapsed(e) {
  //   e.preventDefault();
  //   dispatch(actions.toggleSetting("isCollapsed"));
  //   resize();
  // }

  // function asideCollapsed(e) {
  //   e.preventDefault();
  //   dispatch(actions.toggleSetting("asideToggled"));
  //   resize();
  // }

  // function resize() {
  //   // all IE friendly dispatchEvent
  //   const evt = document.createEvent("UIEvents");
  //   evt.initUIEvent("resize", true, false, window, 0);
  //   window.dispatchEvent(evt);
  //   // modern dispatchEvent way
  //   // window.dispatchEvent(new Event('resize'));
  // }

  function toggleOffsidebar(e) {
    e.preventDefault();
    dispatch(toggleSetting("offsidebarOpen"));
  }

  return (
    <>
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <nav className="navbar topnavbar navbar-expand-md navbar-dark">
          {/* START Left navbar */}
          <div className="navbar-header ps-4 ps-md-0 ps-sm-5">
            <div className="navbar-brand ps-4 ps-lg-0 ps-md-0 ps-sm-0">
              <div className="pe-0">
                <Link to={`/dockets#${date}/${restaurantId}`} className="ps-2">
                  <img className="header-logo header-logo--sm" src="img/WizButler-Logo-42px-sm.png" alt="App Logo" />
                  <img className="header-logo header-logo--lg" src="img/WizButler-Operations-logo.png" alt="App Logo" />
                  <span className={classNames({ "nav-active": navItem == "dockets" }, "btn btn-link my-auto ps-md-3 text-white")} style={{ fontSize: "14px" }}>
                    Dockets
                  </span>
                </Link>
              </div>
            </div>
            <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
          </div>

          {/* END navbar header */}

          {/* START Nav wrapper */}
          <Collapse isOpen={isOpen} navbar className="d-flex justify-content-end">
            {/* <Nav navbar className="mr-auto flex-column flex-lg-row"></Nav> */}
            <Nav className="flex-row align-items-center" navbar>
              <div className="ru-actions">
                <RestaurantSwitcher />
                <button
                  type="button"
                  className="ru-icon-btn"
                  aria-label={isFullscreen ? "Exit full screen" : "Full screen"}
                  title={isFullscreen ? "Exit full screen" : "Full screen"}
                  onClick={toggleFullscreen}
                >
                  {isFullscreen ? <Minimize size={20} strokeWidth={2} /> : <Maximize size={20} strokeWidth={2} />}
                </button>
                <AppSwitcher />
                <button type="button" className="ru-icon-btn" aria-label="Settings" data-offsidebar-toggle onClick={toggleOffsidebar}>
                  <Menu size={20} strokeWidth={2} />
                </button>
              </div>
            </Nav>
          </Collapse>
          {/* END Nav wrapper */}
        </nav>
        {/* END Top Navbar */}
        {/* <div className="btn-standard" style={{ height: '10px' }}></div> */}
        {location.pathname == "/dockets" || location.pathname == "/transactions" || location.pathname === "/" ? (
          <div
            className={classNames({
              "bg-standard ": maestroMode === 0,
              "btn-function": maestroMode === 2,
              "btn-sharedSpace": undefined,
              "btn-linkedTable": linkedTable,
              "btn-hiddenDockets": showHiddenDockets, // highlight button red when hidden dockets active
            })}
            style={{ height: "10px" }}
          ></div>
        ) : null}
      </header>
    </>
  );
};

OmsHeader.propTypes = {
  settings: PropTypes.object,
};

export default OmsHeader;
